export const TEXTS = {
  TITLE: 'Удалить группу адресов?',
  SAVE_BUTTON_TEXT: 'Удалить',
  NOTIFICATION_SUCCESS_TEXT: 'Группа адресов удалена',
  NOTIFICATION_ERROR_TOO_LONG_TEXT: 'Максимальная длина названия группы адресов - 128 символов',
  CANCEL: 'Отменить',
  DESCRIPTION: 'Удаление группы разорвет связь между адресами и синхронное воспроизведение прекратится ',
};
